import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import FbtRewardBanner from '@images/owner/fbt_reward_banner.svg';

import BotBanner from '@images/owner/frodobot_banner.svg';

export default function ActivatedRewardDialog(props) {
	const { onClose, open } = props;

	const handleClose = () => {
		onClose();
	};

	return (
		<Dialog
			onClose={handleClose}
			open={open}
			PaperProps={{ sx: { backgroundColor: '#f1f1f1', borderRadius: '25px' } }}
		>
			<DialogTitle sx={{ textAlign: 'center' }}>
				<h3>Activated your FrodoBot!</h3>
			</DialogTitle>
			<DialogContent className="flex flex-col">
				<img
					src={FbtRewardBanner}
					className="mb-[1rem]"
					alt="Activated robot"
				/>

				<div className="max-w-xs bg-white rounded-xl text-center p-[1rem] mb-[1rem]">
					<img
						src={BotBanner}
						alt="Activated robot"
					/>
					<h3 className="mb-0">With your FrodoBot active,</h3>
					<h3 className="mt-0">let’s check the vault.</h3>
					<p className="text-gray-600 text-xs">
						Congratulations! Your FrodoBot is ready to use. To check up on your FrodoBot and what to do with it, we can
						visit the vault. Click below to start!
					</p>
				</div>
				<div className="max-w-xs bg-white rounded-xl text-center p-[1rem]">
					<button
						className="bg-green text-white text-sm w-full p-[15px] rounded-full"
						onClick={handleClose}
					>
						Let's go!
					</button>
				</div>
			</DialogContent>
		</Dialog>
	);
}
